<app-loader [activarLoaderNavegacionRutas]="true"></app-loader>
<router-outlet></router-outlet>
